import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store';
import { API_FINANCE } from '../../../api/finance';
import { setPayoutPlayers, setPayoutStatuses } from '../../../store/apps/financeSlice';

export default function useGetPayoutInfo({ groupId } = {}) {
  const dispatch = useDispatch();
  const statusHash = useAppSelector((state) => state.finance.payout.statusHash);
  const players = useAppSelector((state) => state.finance.payout.players);
  const playersGroup = players[groupId] || [];

  const statusLength = Object.keys(statusHash).length;
  const playerLength = playersGroup?.length;

  const updateStatuses = () => {
    API_FINANCE.payout
      .statuses()
      .then((e) => {
        dispatch(setPayoutStatuses(e.data.list));
      })
      .catch(console.log);
  };

  const updateGates = (casinoId) => {
    return new Promise((rs, rj) => {
      API_FINANCE.payout
        .gates({ casinoId })
        .then((e) => {
          rs(e.data.list);
        })
        .catch(rj);
    });
  };

  const updatePlayers = (groupId) => {
    if (!groupId) return;
    API_FINANCE.payout
      .players({ groupId })
      .then((e) => {
        const list = e.data.list;
        dispatch(setPayoutPlayers({ groupId, data: list }));
      })
      .catch(console.log);
  };

  useEffect(() => {
    if (!statusLength) {
      updateStatuses();
    }
    if (!playerLength) {
      updatePlayers(groupId);
    }
  }, [groupId]);

  return { statusHash, playersGroup, updatePlayers, updateGates };
}
